import Card from '../UI/Card/CardComponent';
import { getDeltaTime } from '../../helpers/getDeltaTime';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { NOTIFICATION } from '../../helpers/constants';
import { Job, Notification } from '../../types/interface';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import store, { useAppDispatch } from '../../store/store';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  thunkMarkNotificationRead,
  singleNotificationHidden,
  singleNotificationRead,
  thunkDeleteNotification,
} from '../../store/slices/notificationSlice';

import { unwrapResult } from '@reduxjs/toolkit';
import { capitalize, numberOfDays, numberOfDaysOpenForWork } from '../../helpers/helperFunctions';

import useTranslate from '../../hooks/useTranslate';
import {
  NotificationCardContainer,
  NotificationCardStyling,
  NotificationContainer,
  NotificationTypography,
} from '../../styled-components/NotificationModalStyledComponents';
import { Box } from '@mui/system';
import useDetectResize from '../../hooks/useDetectResize';
import { Typography } from '@mui/material';
import { fetchMyId, rtkFetchUserInfo } from '../../store/slices/individualSlice';

interface PropNotification {
  notification: Notification;
  closeModal: any;
}

const NotificationCard = (props: PropNotification) => {
  const { notification, closeModal } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const t = useTranslate();

  const myId = useSelector(fetchMyId);
  const myInfo = useSelector(rtkFetchUserInfo);
  const [notificationState, setNotificationState] = useState<Job | null>(null);

  const [navPath, setNavPath] = useState<string>('');

  const { browserWindow } = useDetectResize();
  const isEnglishLocale = (localStorage.getItem('language') || 'en') === 'en' ? true : false;

  useEffect(() => {
    console.info('Notification: ', notification);

    if (notification.notificationType === NOTIFICATION.B2C_JOB_CLOSE_SOON) {
      setNavPath((currState) => (currState = `/jobs/${notification.objectPath}`));
    }
    if (notification.notificationType === NOTIFICATION.B2C_INDIV_MATCH) {
      setNavPath((currState) => (currState = `/jobs/${notification.objectPath}`));
    }
    if (notification.notificationType === NOTIFICATION.B2C_EJI_UPDATED) {
      setNavPath((currState) => (currState = `/myjobmatches`));
    }
    if (notification.notificationType === NOTIFICATION.B2C_EJI_NOT_A_MATCH) {
      setNavPath((currState) => (currState = `/jobs`));
    }
    if (notification.notificationType === NOTIFICATION.B2C_INDIV_UPDATED) {
      setNavPath((currState) => (currState = `/activity`));
    }
  }, [notification]);

  const getIndividualName = (id: string) => {
    return id;
  };

  const notificationMessage = (notification: Notification) => {
    let endOfSentence = <></>;

    switch (notification.notificationType) {
      case NOTIFICATION.B2C_JOB_CLOSE_SOON:
        let days = numberOfDays(notification.alertUser!);

        endOfSentence = (
          <>
            The &nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              <i>{notification.notificationNoun}</i>
            </span>
            &nbsp;job you liked/applied for&nbsp;
            {t('jobClosingNotif2')}
            <b>
              {days > 0
                ? ` ${t('jobClosingNotif3')} ${
                    days > 1 ? days + ' ' + t('jobClosingNotif4') : days + ' day'
                  } 🕓🕓🕓`
                : ` ${t('jobClosingNotif5')} 🕓🕓🕓`}
            </b>
          </>
        );
        break;
      case NOTIFICATION.B2C_JOB_REOPEN:
        endOfSentence = (
          <>
            {t('notification-reOpen1')}
            &nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              <i>{notification.notificationNoun}</i>
            </span>
            &nbsp;{t('notification-reOpen2')}&nbsp;
          </>
        );
        break;
      case NOTIFICATION.B2C_INDIV_MATCH:
        endOfSentence = (
          <>
            🧩 {t('notification-jobMatch1')} <b>{notification.notificationNoun2}</b>!{' '}
            {t('notification-view')}&nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              {t('notification-jobPosting')}
            </span>
            &nbsp;{t('notification-jobMatch2')}
          </>
        );
        break;
      case NOTIFICATION.B2C_EJI_UPDATED:
        endOfSentence = (
          <>
            &nbsp;{t('notification-view')}&nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              {t('notification-activeApplications1')}
            </span>
            {/*<Link*/}
            {/*  to="/myjobmatches"*/}
            {/*  state={{ showStartedApplications: true }}*/}
            {/*  // onClick={navigateHandler}*/}
            {/*>*/}
            {/*  <b>{t('notification-activeApplications1')}</b>*/}
            {/*</Link>*/}
            &nbsp;{t('notification-activeApplications2')}
          </>
        );
        break;
      case NOTIFICATION.B2C_EJI_NOT_A_MATCH:
        endOfSentence = (
          <>
            &nbsp;{t('notification-notAMatch1')}&nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              <b>{t('jobsSection')}</b>
            </span>
            &nbsp;{t('notification-notAMatch2')}
          </>
        );
        break;
      case NOTIFICATION.B2C_EJI_OFFER:
        endOfSentence = <>&nbsp;{t('notification-offer')}</>;
        break;
      case NOTIFICATION.B2C_INDIV_UPDATED:
        endOfSentence = (
          <>
            {t('notification-indivUpdated1')}&nbsp;
            <span className="notif-noun-link" onClick={navigateHandler}>
              {t('notification-indivUpdated2')}
            </span>
            &nbsp;{t('notification-indivUpdated3')}
          </>
        );
        break;
      default:
        endOfSentence = (
          <>
            ⚠️⚠️⚠️ unaccounted condition: notificationType = {notification.notificationType}⚠️⚠️⚠️
          </>
        );
    }

    return (
      <>
        {notification.notificationType === NOTIFICATION.B2C_EJI_UPDATED ? (
          <>
            🔄{t('notification-ejiUpdated1')}&nbsp;
            <Typography
              className="notif-noun-link"
              component="span"
              fontWeight="600"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(`/jobs/${notification.objectPath}`);
              }}
            >
              {notification.notificationNoun}
            </Typography>
            &nbsp;{t('notification-ejiUpdated2')}
          </>
        ) : notification.notificationType === NOTIFICATION.B2C_EJI_NOT_A_MATCH ? (
          <>
            🚩
            <Typography
              className="notif-noun-link"
              component="span"
              fontWeight="600"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(`/jobs/${notification.objectPath}`);
              }}
            >
              The {notification.notificationNoun}
            </Typography>
            &nbsp;
          </>
        ) : notification.notificationType === NOTIFICATION.B2C_EJI_OFFER ? (
          <>
            🎉 {t('notification-typeOffer1')}&nbsp;
            <Typography
              className="notif-noun-link"
              component="span"
              fontWeight="600"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(`/jobs/${notification.objectPath}`);
              }}
            >
              {notification.notificationNoun}
            </Typography>
            &nbsp;{t('notification-typeOffer2')}
          </>
        ) : notification.notificationType === NOTIFICATION.B2C_INDIV_UPDATED ? (
          <Typography component="span" className="notif-noun">
            ✏️ {myInfo?.leadProviderName} {t('notification-ejiUpdatedProfile')}&nbsp;
          </Typography>
        ) : notification.notificationType.startsWith('INDIVIDUAL') &&
          !notification.notificationType.endsWith('MATCH') ? (
          <span className="notif-noun">{notification.notificationNoun}</span>
        ) : (
          <></>
        )}
        {endOfSentence}
      </>
    );
  };

  const navigateHandler = () => {
    if (notification.notificationType === NOTIFICATION.B2C_EJI_UPDATED) {
      navigate(navPath, { state: { showStartedApplications: true } }); //programatically open activity panel
    } else {
      navigate(navPath);
    }
  };

  const markRead = () => {
    dispatch(
      thunkMarkNotificationRead({
        myProviderId: myId!,
        notification: notification,
      })
    )
      .then(unwrapResult)
      .then((status) => {
        status === 200
          ? dispatch(
              singleNotificationRead({
                ts: notification.createdAt,
                path: notification.objectPath,
                type: notification.notificationType,
              })
            )
          : alert(`${t('notifcation-tryAgainError')}`);
      });
  };

  const markHidden = () => {
    console.warn(notification.uid);
    dispatch(
      thunkDeleteNotification({
        notificationId: notification.uid,
      })
    )
      .then(unwrapResult)
      .then((status) => {
        status === 200
          ? dispatch(
              singleNotificationHidden({
                ts: notification.createdAt,
                path: notification.objectPath,
                type: notification.notificationType,
              })
            )
          : alert('Sorry, something went wrong in markHiddenClick');
      });
  };

  return (
    <>
      {notification.isVisible && (
        <NotificationCardContainer
          className={!notification.isRead ? 'notif-highlight' : 'notif-unread'}
          onClick={() => {
            markRead();
            closeModal();
          }}
        >
          <NotificationContainer>
            <NotificationCardStyling width={browserWindow.w}>
              <NotificationTypography className="notification-message" variant="body1">
                {notificationMessage(notification)}
                <br />
                <Typography variant="caption" className="notification-time">
                  {getDeltaTime(notification.createdAt, t, isEnglishLocale)}
                </Typography>
              </NotificationTypography>
            </NotificationCardStyling>

            <Box className="meat-balls">
              <IconButton
                color="inherit"
                onClick={(e) => {
                  markHidden();
                  e.stopPropagation();
                }}
              >
                {<DeleteOutlineOutlinedIcon />}
              </IconButton>
            </Box>
          </NotificationContainer>
        </NotificationCardContainer>
      )}
    </>
  );
};

export default NotificationCard;
